module.exports = __webpack_public_path__ + "static/media/courses.7a167346.svg";